export default (node) => {
  /**
   * Data + elements
   */
  const faqGroups = document.querySelectorAll('[data-faq-group-item]');

  /**
   * Functions
   */

  const changeGroup = (e) => {
    const sectionId = e.currentTarget.getAttribute('data-button-header');
    // scroll to sectionId
    const section = document.querySelector(
      `[data-faq-group-item="${sectionId}"]`
    );
    if (section) {
      const offset = section.offsetTop - 100;
      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      });
    }

    // update the active class
    const buttons = node.querySelectorAll('[data-button-header]');
    if (buttons) {
      buttons.forEach((button) => {
        button.classList.remove('group-active');
        if (button.getAttribute('data-button-header') === sectionId) {
          button.classList.add('group-active');
        }
      });
    }
  };

  const initButtons = () => {
    const buttons = node.querySelectorAll('[data-button-header]');
    if (buttons) {
      buttons.forEach((button) => {
        button.addEventListener('click', changeGroup);
      });
    }
  };

  const createHeader = () => {
    if (faqGroups) {
      faqGroups.forEach((faqGroup, index) => {
        const header = document.createElement('button');
        header.classList.add(
          'text-label-xs',
          'md:text-label-md',
          'w-fit',
          'text-text-tertiary',
          'uppercase',
          'group-inactive',
          'md:h-12',
          'h-11'
        );
        if (index === 0) {
          header.classList.add('group-active');
        }
        header.setAttribute(
          'data-button-header',
          faqGroup.getAttribute('data-faq-group-item')
        );
        header.textContent = faqGroup.querySelector(
          '[data-faq-group-title]'
        ).textContent;
        node.insertAdjacentElement('beforeend', header);
      });

      initButtons();
    }
  };

  /**
   * Init
   */
  const init = () => {
    createHeader();
  };

  init();
};
